import React, { useState, memo } from "react";
import { Col, Row } from "react-bootstrap";

import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import ActionDropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import ReportData from "./ReportData";

const reportTypes = [
  {
    value: "company",
    label: "Company High Scores"
  },
  {
    value: "my-scores",
    label: "My High Scores"
  }
];

const filterTypes = [
  {
    value: "all",
    label: "All History"
  },
  {
    value: "18-months",
    label: "18 Months"
  }
];

const Report = memo(() => {
  const [currentReport, setCurrentReport] = useState("company");
  const [currentPeriod, setCurrentPeriod] = useState("all");

  return (
    <Col>
      <Row>
        <Col md={12}>
          <div className="page-header page-header-bar">
            <h1>
              <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
                {false && (
                  <ActionDropDown
                    menuClass="dropdown-menu-right"
                    style={{ cursor: "pointer" }}
                    label="Report"
                  >
                    {reportTypes.map(report => (
                      <DropDownItem
                        key={report.value}
                        onClick={() => setCurrentReport(report.value)}
                      >
                        <span>
                          {currentReport === report.value && (
                            <i className="fa fa-fw fa-check" />
                          )}
                          {currentReport !== report.value && (
                            <React.Fragment>
                              &nbsp;&nbsp;&nbsp;&nbsp;
                            </React.Fragment>
                          )}{" "}
                          <span>{report.label}</span>
                        </span>
                      </DropDownItem>
                    ))}
                  </ActionDropDown>
                )}
              </div>
              <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
                <ActionDropDown
                  menuClass="dropdown-menu-right"
                  style={{ cursor: "pointer" }}
                  label="Filter"
                >
                  {filterTypes.map(report => (
                    <DropDownItem
                      key={report.value}
                      onClick={() => setCurrentPeriod(report.value)}
                    >
                      <span>
                        {currentPeriod === report.value && (
                          <i className="fa fa-fw fa-check" />
                        )}
                        {currentPeriod !== report.value && (
                          <React.Fragment>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                          </React.Fragment>
                        )}{" "}
                        <span>{report.label}</span>
                      </span>
                    </DropDownItem>
                  ))}
                </ActionDropDown>
              </div>
              High Scores
            </h1>
          </div>
        </Col>
      </Row>

      <ReportData
        key={`${currentReport}.${currentPeriod}`}
        period={currentPeriod}
        report={currentReport}
      />
    </Col>
  );
});

export default Report;



// WEBPACK FOOTER //
// ./app/modules/HighScores/components/Report/Report.jsx